import './Event.scss'

import React, { useRef } from 'react'
import { TimelineEvent } from '../../../../CommonComponents/timeline/Timeline';
import usePopover from '../../../../CommonComponents/popover/usePopover';
import { mergeClassNames } from '../../../../../utils/commonFunctions';

interface EventProps {
    className?: string;
    startTime: number;
    endTime: number;
    eventName: string;
    icon?: React.ReactNode;
    allEvents: any[];
    overlay?: React.ComponentType<{ Events: any[] }>
    onClick?: () => void
}

const Event: React.FC<EventProps> = ({ startTime, endTime, eventName, icon, allEvents, overlay: Overlay, className = '', onClick }) => {

    const elRef = useRef<HTMLDivElement | null>(null);
    const { showPopover } = usePopover();

    const isTimeOverlap = (aStart: number, aEnd: number, bStart: number, bEnd: number) => Math.max(aStart, bStart) <= Math.min(aEnd, bEnd);

    const handleMouseEnter = () => {
        if (!elRef.current || !Overlay) return;
        const rect = elRef.current.getBoundingClientRect();
        const overlapped = allEvents.filter((ev) => isTimeOverlap(startTime, endTime, ev.startTime, ev.endTime));
        showPopover(rect, (<Overlay Events={overlapped} />));
    };

    return (
        <TimelineEvent eventStart={startTime} eventEnd={endTime}>
            <div
                ref={elRef}
                onMouseEnter={handleMouseEnter}
                onClick={onClick}
                className={mergeClassNames(`event__container`, className)}
            >
                {icon && <div className='event__icon'>{icon}</div>}
                <span className='event__text'>{eventName}</span>
            </div>
        </TimelineEvent>
    )
}

export default Event